<template>
  <label
    class="inline-flex items-center cursor-pointer"
    :class="{ 'opacity-50 cursor-not-allowed': disabled }"
  >
    <!-- Before Label -->
    <div v-if="labelBefore" class="me-3">
      <span class="block text-sm font-medium text-gray-900 dark:text-gray-300">
        {{ labelBefore }}
      </span>
      <span
        v-if="subheaderBefore"
        class="block text-xs text-gray-500 dark:text-gray-400 mt-px"
      >
        {{ subheaderBefore }}
      </span>
    </div>

    <!-- Toggle Switch -->
    <input
      type="checkbox"
      :checked="checked"
      :disabled="disabled"
      class="sr-only peer"
      @change="$emit('update:checked', $event.target.checked)"
    />
    <div
      :class="[
        'relative bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[\'\'] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:transition-all dark:border-gray-600 peer-checked:bg-blue-600',
        sizeClasses[size],
        disabled ? 'pointer-events-none' : ''
      ]"
    ></div>

    <!-- After Label -->
    <div v-if="labelAfter" class="ms-3">
      <span class="block text-sm font-medium text-gray-900 dark:text-gray-300">
        {{ labelAfter }}
      </span>
      <span
        v-if="subheaderAfter"
        class="block text-xs text-gray-500 dark:text-gray-400 mt-px"
      >
        {{ subheaderAfter }}
      </span>
    </div>
  </label>
</template>

<script>
export default {
  name: "ToggleSwitch",
  props: {
    size: {
      type: String,
      default: "medium",
      validator(value) {
        return ["small", "medium", "large"].includes(value);
      }
    },
    labelBefore: {
      type: String,
      default: ""
    },
    labelAfter: {
      type: String,
      default: ""
    },
    subheaderBefore: {
      type: String,
      default: null
    },
    subheaderAfter: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:checked"],
  computed: {
    sizeClasses() {
      return {
        small: "w-9 h-5 after:top-[2px] after:start-[2px] after:h-4 after:w-4",
        medium:
          "w-11 h-6 after:top-[2px] after:start-[2px] after:h-5 after:w-5",
        large: "w-14 h-7 after:top-0.5 after:start-[4px] after:h-6 after:w-6"
      };
    }
  }
};
</script>

<style scoped></style>
